module.exports = __webpack_public_path__ + "static/media/printing_invoices_amber.741b9bd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/printing_invoices_amber.svg
// module id = 1089
// module chunks = 2